import React, { useEffect } from 'react'
import { desktopAssets, fixedAssets } from 'src/containers/PreCache'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'
import config from '../config'
import { SIZES } from '../styles/theme'
import { useAutoMute } from '../utils/useAutoMute'
import PageWithBg from 'src/components/PageWithBg'
import { showGlobalModal } from 'src/ducks/layout'
import { GlobalModalTypes } from 'src/components/GlobalModals/modalTypes'
import { useDispatch } from 'react-redux'
import { useAuditoriumController } from 'src/utils/useAuditoriumController'
import { Loader } from 'src/components/shared/Loader'
import routes from 'src/routes'
import { useHistory } from 'react-router'

const Page = styled.div`
  overflow: hidden;

  .controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
    gap: 2rem;

    button {
      background: linear-gradient(90deg, #ae8341 0%, #f2c370 50%, #ae8341 100%);
      color: #fff;
      border: 0;
      outline: 0;
      padding: 12px 55px;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.15s ease-in-out, opacity 0.15s ease-in-out;

      font-size: 20px;
      font-family: 'Din', 'DIN', sans-serif;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);

      &:hover:not(:disabled) {
        transform: translateY(-2px);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &.home-button {
        box-sizing: border-box;
        width: 50px;
        height: 50px;
        flex: 0 0 50px;
        padding: 10px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 30px;
          height: 30px;
          display: block;
          object-fit: contain;
        }
      }
    }
  }

  .video {
    background: black;
    width: 790px;
    height: 100%;
    min-height: 470px;
    aspect-ratio: 16/9;
    margin-bottom: 1rem;
  }

  .content {
    ${config.layout.auditoriumVid}
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: fit-content;
    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 1rem;

    .organizer-logo {
      max-width: 130px;
    }

    .banner {
      max-width: 650px;
    }
  }

  .chat {
    max-width: 425px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 70%;
    bottom: 0;
    right: 5%;
    z-index: 30;
    margin: 0 auto;
    background: #242526;
  }
  #programme-btn {
    position: absolute;
    top: 10%;
    left: 0;
    margin-top: 30px;
    display: block;
    span {
      cursor: pointer;
      background: rgba(0, 0, 0, 1);
      opacity: 0.8;
      color: #f8c605;
      position: absolute;
      font-weight: 600;
      font-size: 18px;
      height: 60px;
      width: 180px;
      text-transform: uppercase;
      letter-spacing: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 28px 28px 0px 0px;
      transform: rotate(90deg) translateY(60px);
      transition: all 200ms ease-in;
      &:hover {
        color: #000;
        background: rgba(248, 198, 5, 1);
        border: 2px solid #000;
      }
    }
  }

  @media (min-width: 1440px) {
    .content {
      top: 10%;
    }

    .video {
      width: 100%;
    }
  }

  @media (min-width: 1920px) {
    .content {
      top: 5%;
    }

    .video {
      width: 100%;
      height: 100%;
      aspect-ratio: 16/9;
      /* max-height: 572px; */
    }

    .header {
      .organizer-logo {
        max-width: 230px;
      }

      .banner {
        max-width: 1050px;
      }
    }
  }
`

export default function AuditoriumPage({ currentUser }) {
  const history = useHistory()
  useAutoMute()
  const hasAuditoriumAccess = useAuditoriumController(currentUser)
  const dispatch = useDispatch()

  useEffect(() => {
    document.title = `${config.eventName} | Auditorium`
    Amplitude.visit('Auditorium')
  }, [])

  if(!hasAuditoriumAccess) {
    return <Loader />
  }

  return (
    <Page>
      <PageWithBg bgImg={desktopAssets.auditoriumBg}>
        <div className="mx-auto chat">
          <iframe src={config.SLIDO_URL} height="100%" width="100%" frameBorder="0" style={{ minHeight: '600px' }} title="Slido"></iframe>
        </div>
        <div className="content">
          {/* <div className="header">
            <img src={fixedAssets.organizerLogo} alt="Auditorium Organizer" className="organizer-logo img-fluid" />
            <img src={fixedAssets.auditoriumBanner} alt="Auditorium Banner" className="banner img-fluid" />
          </div> */}
          {/* <img src={fixedAssets.auditoriumBanner} alt="Auditorium Banner" className="banner img-fluid" /> */}
          <div className="video">
            <iframe
              title="auditorium-stream"
              id="1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6-live-507a30e6-8cf4-adb9-bbb4-
5711d8ba79da"
              src={config.HALL_VIDEO_URL}
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              allow="autoplay;encrypted-media;fullscreen"
              allowfullscreen
              webkitallowfullscreen
              mozallowfullscreen
              oallowfullscreen
              msallowfullscreen
            ></iframe>
            {/* <iframe 
              title="intro-video" 
              id="1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6-vod-8204943d-6716-4a4f-a01a-d86a766cbcc3" 
              src="https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/8204943d-6716-4a4f-a01a-d86a766cbcc3" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              scrolling="no" 
              allow="autoplay;encrypted-media" 
              allowFullScreen></iframe> */}
          </div>
          <div className="controls">
            <button className="home-button" onClick={() => history.push(routes.lobby)} aria-label="Back to lobby">
              <img src={fixedAssets.homeButtonIcon} alt="" aria-hidden="true" />
            </button>
            <button onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Agenda))}>Programme</button>
            <button onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Speakers))}>Speakers</button>
          </div>
        </div>
        {/* <div id="programme-btn" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Agenda))}>
          <span>Programme</span>
        </div> */}
      </PageWithBg>
    </Page>
  )
}
